
  export const style={
    inpuStyle:{
      colorInput:"#147F40"
    },
    url:{
      urlClient:"https://bosque.prd.appnoz.com.br/",
      urlClientYouseed:"https://admyouseed.bancosemear.com.br/"
    },
    fileUrl:{
      logo:"https://timcoo-geral.s3.us-east-1.amazonaws.com/Logos/primary_logo_client_bosque.jpg",
      secondaryLogonLogo: "null",
    },
    variables:{
       customMenuItem: false,
       autoRegister: false,
       recaptchaVersion : "V1"
    },
    CurrencyName:{
      name:"Noz/Nozes"
    },
    teamName:{
      name:"Bosque"
    },
    hasToken: false,
    hostHeader: "bosque"
  }
